module.exports = __webpack_public_path__ + "img/SES_Slimliner_II_Profiles.65d71585.jpg";